import React from 'react';
import PropTypes from 'prop-types';
import useI18n from 'hooks/I18n/useI18n';
import classnames from 'classnames';
import Icon from 'components/Icon.jsx';
import HelpPanel from 'components/Navigation/ProductIdentity/HelpPanel.jsx';
import PIText from 'components/ProductIdentity/Text.jsx';
import helpCircleIcon from 'app/assets/new-design/images/icons/help.svg';
import useResponsive from 'hooks/Navigation/useResponsive';

const HelpButton = props => {
    const { trans } = useI18n();
    const { currentAssembly, farm, currentUser, openHelpMenu, open, fullHeight } = props;

    const isTabletOrMobile = useResponsive(991);

    return (
        <>
            <button
                className={classnames(
                    'simpleMemberTopRightMenu-panel simpleMemberTopNavigation-button help-button',

                    'without-end-border'
                )}
                onClick={openHelpMenu}
            >
                {isTabletOrMobile ? (
                    <Icon src={helpCircleIcon} color="white" size="xx-large" />
                ) : (
                    <PIText size="14px" color="white">
                        {trans('header.helpAndAdvice')}
                    </PIText>
                )}
            </button>

            {open && (
                <HelpPanel
                    user={currentUser}
                    currentAssembly={currentAssembly || null}
                    farm={farm}
                    fullHeight={fullHeight}
                />
            )}
        </>
    );
};
HelpButton.propTypes = {
    currentAssembly: PropTypes.object,
    farm: PropTypes.object,
    currentUser: PropTypes.object,
    openHelpMenu: PropTypes.func,
    open: PropTypes.func,
    fullHeight: PropTypes.bool,
};
export default HelpButton;
